import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=d5ce55fa&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=d5ce55fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ce55fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5ce55fa')) {
      api.createRecord('d5ce55fa', component.options)
    } else {
      api.reload('d5ce55fa', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=d5ce55fa&scoped=true&", function () {
      api.rerender('d5ce55fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Xim28Fmy9ep3/JS/comp/CookieBox.vue"
export default component.exports